import { isWeb, getPlatform } from '../src/utils/platformUtils'
import { SCHEDULES_STORE_NAMES } from '../src/db/constants'
import {
    FORM_SCHEDULE_STATUS,
    STATUS_FORM_PENDING_SYNC,
} from '../src/components/stores/constants/constants.stores'
import { LEARNING_STORE_NAMES } from './learning.database'
import { BENEFITS_STORE_NAMES } from '../src/db/constants'
import { POST_TABLE_NAMES } from '../src/db/constants'
import { TRACKINGS } from './tracking.database'
import { PORTFOLIO_STORE_NAMES } from '../src/db/constants'
import { openDB } from '../src/db/indexDB'
// Database helper utilities

const FOOTER_APP = 'footer_app'
const USER_PROFILE = 'user_profiles'
const postsStoreName = 'posts'
const REACTIONS = 'reactions'
let __dbModule = null
let __userRepositoryModule = null // ✅ Cache para el módulo user.repository

// ✅ Importar getRealDatabase y finalizeStatement desde DatabaseSingleton (única fuente de verdad)
import {
    getRealDatabase,
    finalizeStatement,
} from '../database-sqlite/DatabaseSingleton'
import { getDb } from '../db-sqlite/adapter'

// ✅ Migración de footer_index movida a initializeTables() en DatabaseSingleton
// La migración ahora se ejecuta automáticamente al inicializar las tablas

// ✅ LIMPIEZA: buildLocalWrappedDb, getWrappedDB y openDatabase eliminados - ahora todo usa DatabaseSingleton.getRealDatabase()

const versionsStoreName = 'versions'

class userServices {
    constructor() {
        // Métodos usan getRealDatabase() o db.transaction según contexto
    }

    /**
     * @description updatea la tabla footer por lo que recibe por param
     * @param {*} newData single.data.footer_app
     * @deprecated
     * @returns
     *
     * ❌ DEPRECADO: Este archivo será removido en futuras versiones
     * ✅ MIGRADO: Ahora delega al repository moderno (SDK 54)
     * 🐛 FIX: Eliminada columna 'name' que causaba:
     *         "Error code : table footer_app has no column named name"
     */
    updateFooter = async (newData) => {
        try {
            // ✅ Lazy-load del repository moderno (evita import circular)
            if (!__userRepositoryModule) {
                __userRepositoryModule =
                    await import('../db-sqlite/repositories/user.repository')
            }

            // ✅ Delegar al repository optimizado (batch insert + spread operator)
            await __userRepositoryModule.updateFooter(newData)
        } catch (error) {
            console.error(
                '❌ Error en updateFooter (delegación a repository):',
                error,
            )
            throw error
        }
    }

    getFooterApp = async () => {
        try {
            // ✅ UNIFICADO: Usar DatabaseAdapter tanto en web como en native
            if (isWeb()) {
                // Web usa DatabaseAdapter.web (localStorage fallback)
                const { getDatabaseAdapter } =
                    await import('../src/db/DatabaseAdapter')
                const adapter = getDatabaseAdapter('myDB')
                await adapter.initialize()

                const result = await adapter.getAllAsync(
                    `SELECT * FROM ${FOOTER_APP};`,
                )
                const footer_app = result.map((item) => ({
                    ...item,
                    index: item.footer_index,
                }))

                console.log(
                    `✅ [getFooterApp][web] Encontrados ${JSON.stringify(footer_app)} `,
                )
                return footer_app
            } else {
                // Native usa DatabaseAdapter.native -> DatabaseSingleton
                const realDb = await getRealDatabase()

                const result = await realDb.getAllAsync(
                    `SELECT * FROM ${FOOTER_APP};`,
                )
                const footer_app = result.map((item) => ({
                    ...item,
                    index: item.footer_index,
                }))

                console.log(
                    `✅ [getFooterApp][native] Encontrados ${footer_app.length} items`,
                )
                return footer_app
            }
        } catch (error) {
            console.error('❌ [getFooterApp] Error:', error)
            throw error
        }
    }

    getNavApp = async () => {
        try {
            if (isWeb()) {
                const { openDB } = await import('../src/db/indexDB')
                const db = await openDB()

                const tx = db.transaction(['nav_app'], 'readonly')
                const store = tx.objectStore('nav_app')
                const request = store.getAll()

                return await new Promise((resolve, reject) => {
                    request.onsuccess = (event) => {
                        resolve(event.target.result || [])
                    }
                    request.onerror = () => reject(request.error)
                })
            }

            const realDb = await getRealDatabase()
            const result = await realDb.getAllAsync(
                `SELECT * FROM ${FOOTER_APP} WHERE nav = 1`,
            )

            return result || []
        } catch (error) {
            console.error('getNavApp error:', error)
            throw error
        }
    }

    getSectionApp = async () => {
        try {
            if (isWeb()) {
                const { openDB } = await import('../src/db/indexDB')
                const db = await openDB()

                const tx = db.transaction([FOOTER_APP], 'readonly')
                const store = tx.objectStore(FOOTER_APP)
                const request = store.getAll()

                return await new Promise((resolve, reject) => {
                    request.onsuccess = (event) => {
                        resolve(event.target.result || [])
                    }
                    request.onerror = () => reject(request.error)
                })
            }

            const realDb = await getRealDatabase()
            const result = await realDb.getAllAsync(
                `SELECT * FROM ${FOOTER_APP} WHERE section = 1`,
            )

            return result || []
        } catch (error) {
            console.error('getSectionApp error:', error)
            throw error
        }
    }

    getGlobalVersion = (serviceName) => {
        // console.log('🔍 [getGlobalVersion] START for serviceName:', serviceName)
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                try {
                    const database = await openDB()
                    const transaction = database.transaction(
                        [versionsStoreName],
                        'readonly',
                    )
                    const objectStore = transaction.objectStore(versionsStoreName)
                    const request = objectStore.get(serviceName)

                    request.onsuccess = (event) => {
                        const version = event.target.result
                        // console.log('✅ [getGlobalVersion] WEB result:', version ? version.value : null)
                        resolve(version ? version.value : null)
                    }

                    request.onerror = (event) => {
                        console.error(
                            '❌ [getGlobalVersion] WEB error:',
                            event.target.error,
                        )
                        reject(event.target.error)
                    }
                } catch (error) {
                    console.error(
                        'Error accessing IndexedDB in getGlobalVersion:',
                        error,
                    )
                    resolve(null)
                }
            } else {
                // Usar DatabaseSingleton en lugar de db.transaction legacy
                try {
                    // console.log('🔍 [getGlobalVersion] Getting realDb instance...')
                    const realDb = await getRealDatabase()
                    // console.log('✅ [getGlobalVersion] realDb obtained, querying...')
                    const result = await realDb.getFirstAsync(
                        `SELECT value FROM ${versionsStoreName} WHERE serviceName = ?;`,
                        [serviceName],
                    )
                    // console.log('✅ [getGlobalVersion] NATIVE result:', result)
                    resolve(result ? result.value : null)
                } catch (error) {
                    console.error('❌ [getGlobalVersion] NATIVE error:', error)
                    resolve(null) // No reject - retornar null si falla
                }
            }
        })
    }

    updateGlobalVersion = async (serviceName, new_version, retryCount = 0) => {
        const MAX_RETRIES = 3
        const RETRY_DELAY = 100 // ms

        console.log(
            '📝 [updateGlobalVersion] START - serviceName:',
            serviceName,
            'new_version:',
            new_version,
            'type:',
            typeof new_version,
        )

        try {
            if (isWeb()) {
                const { openDB } = await import('../src/db/indexDB')
                const db = await openDB()

                const tx = db.transaction([versionsStoreName], 'readwrite')
                const store = tx.objectStore(versionsStoreName)

                const current = await new Promise((resolve, reject) => {
                    const req = store.get(serviceName)
                    req.onsuccess = () => resolve(req.result?.value ?? null)
                    req.onerror = () => reject(req.error)
                })

                if (current !== new_version) {
                    console.log(
                        '📝 [updateGlobalVersion] WEB - Updating from',
                        current,
                        'to',
                        new_version,
                    )
                    store.put({ serviceName, value: new_version })
                } else {
                    console.log(
                        '📝 [updateGlobalVersion] WEB - Version unchanged:',
                        current,
                    )
                }

                return true
            }

            const realDb = await getRealDatabase()
            console.log(
                '📝 [updateGlobalVersion] NATIVE - Executing INSERT OR REPLACE with:',
                { serviceName, new_version },
            )

            // ✅ SOLUCIÓN: Usar nombres de columna explícitos y runAsync con prepare para mayor control
            const stmt = await realDb.prepareAsync(
                `INSERT OR REPLACE INTO ${versionsStoreName} (serviceName, value) VALUES (?, ?);`,
            )
            try {
                await stmt.executeAsync([serviceName, new_version])
                console.log(
                    '✅ [updateGlobalVersion] NATIVE - executeAsync completed successfully',
                )
            } finally {
                await finalizeStatement(stmt)
            }

            // 🔍 VERIFICACIÓN: Leer inmediatamente después de guardar
            const verifyStmt = await realDb.prepareAsync(
                `SELECT value FROM ${versionsStoreName} WHERE serviceName = ?;`,
            )
            let row = null
            try {
                const result = await verifyStmt.executeAsync([serviceName])
                row = await result.getFirstAsync()
            } finally {
                await finalizeStatement(verifyStmt)
            }

            console.log(
                '🔍 [updateGlobalVersion] VERIFICATION - serviceName:',
                serviceName,
                '- Stored value:',
                row?.value,
                'type:',
                typeof row?.value,
            )

            if (row?.value != new_version) {
                // usar != para comparar null/undefined/number
                console.error(
                    '❌ [updateGlobalVersion] MISMATCH! Expected:',
                    new_version,
                    'Got:',
                    row?.value,
                )
                console.error('❌ [updateGlobalVersion] Full row:', row)

                // 🔍 DEBUG: Verificar si la tabla existe y tiene datos
                const debugStmt = await realDb.prepareAsync(
                    `SELECT COUNT(*) as count FROM ${versionsStoreName};`,
                )
                try {
                    const debugResult = await debugStmt.executeAsync([])
                    const debugRow = await debugResult.getFirstAsync()
                    console.log(
                        '🔍 [DEBUG] Total rows in versions table:',
                        debugRow?.count,
                    )
                } finally {
                    await finalizeStatement(debugStmt)
                }
            } else {
                console.log(
                    '✅ [updateGlobalVersion] VERIFICATION SUCCESS - Value matches!',
                )
            }

            return true
        } catch (error) {
            // ✅ Manejar database locked con retry
            if (
                error.message &&
                error.message.includes('database is locked') &&
                retryCount < MAX_RETRIES
            ) {
                console.warn(
                    `⚠️ [updateGlobalVersion] Database locked, retrying ${retryCount + 1}/${MAX_RETRIES}...`,
                )
                await new Promise((resolve) =>
                    setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                )
                return this.updateGlobalVersion(
                    serviceName,
                    new_version,
                    retryCount + 1,
                )
            }

            console.error('❌ [updateGlobalVersion] ERROR:', error)
            throw error
        }
    }

    getUser = async () => {
        try {
            if (isWeb()) {
                const { openDB } = await import('../src/db/indexDB')
                const db = await openDB()

                const tx = db.transaction([USER_PROFILE], 'readonly')
                const store = tx.objectStore(USER_PROFILE)

                const users = await new Promise((resolve, reject) => {
                    const req = store.getAll()
                    req.onsuccess = () => resolve(req.result)
                    req.onerror = () => reject(req.error)
                })

                return Array.isArray(users) && users.length > 0 ? users[0] : null
            }

            // 📱 Mobile / SQLite
            const realDb = await getRealDatabase()
            const result = await realDb.getFirstAsync(
                `SELECT * FROM ${USER_PROFILE};`,
            )

            if (!result) return null

            let user = result

            // Parseo seguro de user_segment
            try {
                if (typeof user.user_segment === 'string') {
                    user = {
                        ...user,
                        user_segment: JSON.parse(user.user_segment),
                    }
                }
            } catch {
                user = { ...user, user_segment: null }
            }

            return user
        } catch (error) {
            console.error('getUser error:', error)
            throw error
        }
    }

    // updates = { name: "Doh" }
    updateUser = async (user_id, updates) => {
        if (isWeb()) {
            throw new Error('Esta función no es compatible con la plataforma web')
        }

        try {
            // Construir dinámicamente la consulta SQL y los parámetros
            const keys = Object.keys(updates) // Extraer las claves del objeto `updates`
            const values = Object.values(updates) // Extraer los valores del objeto `updates`

            // Crear la parte SET de la consulta SQL
            const setClause = keys.map((key) => `${key} = ?`).join(', ')

            // Agregar el `user_id` al final de los valores
            values.push(user_id)

            const query = `UPDATE ${USER_PROFILE} SET ${setClause} WHERE _id = ?;`

            const realDb = await getRealDatabase()
            const result = await realDb.runAsync(query, values)
            return result
        } catch (error) {
            console.error('SQLite USER error:', error)
            throw error
        }
    }
    getTableNames = () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
            } else {
                // Código para obtener nombres de tablas con expo-sqlite
                try {
                    const realDb = await getRealDatabase()
                    const result = await realDb.getAllAsync(
                        `SELECT name FROM sqlite_master WHERE type='table';`,
                    )
                    const tableNames = result.map((row) => row.name)
                    resolve(tableNames)
                } catch (error) {
                    console.error('getTableNames error:', error)
                    reject(error)
                }
            }
        })
    }

    // getTableData = (tableName, page = 1, pageSize = 100, search) => {
    //     return new Promise((resolve, reject) => {
    //         if (isWeb()) {
    //         } else {
    //             const offset = (page - 1) * pageSize
    //             // Código para obtener los datos de una tabla en expo-sqlite
    //             db.transaction(
    //                 (tx) => {
    //                     tx.executeSql(
    //                         `SELECT * FROM ${tableName} ORDER BY ROWID ASC LIMIT ? OFFSET ?;`,
    //                         //`SELECT * FROM ${tableName};`,
    //                         [pageSize, offset],
    //                         (_, result) => {
    //                             //console.log("🚀 ~ userServices ~ returnnewPromise ~ result:", result)
    //                             resolve(result.rows._array) // Devuelve las filas de la tabla
    //                         },
    //                         (_, error) => {
    //                             reject(error)
    //                         },
    //                     )
    //                 },
    //                 (error) => {
    //                     console.error('SQLite error:', error)
    //                     reject(error)
    //                 },
    //                 null,
    //             )
    //         }
    //     })
    // }
    getTableData = (tableName, page = 1, pageSize = 100, search = '') => {
        console.log('🚀 ~ userServices ~ search:', search)
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                // Manejar la lógica para web si es necesario
                resolve(null)
            } else {
                const offset = (page - 1) * pageSize
                let query = `SELECT * FROM ${tableName}`
                let params = [pageSize, offset]

                // Si hay búsqueda, construimos la condición WHERE
                if (search) {
                    try {
                        const [campo, operador, valor] = search
                            .split(',')
                            .map((s) => s.trim())

                        // Validamos que el operador sea permitido
                        const validOperators = ['=', '!=', '>', '<', '>=', '<=']
                        if (!validOperators.includes(operador) && valor !== 'NULL') {
                            throw new Error('Operador no válido')
                        }

                        // query += ` WHERE ${campo} ${operador} ?`;
                        // params = [valor, pageSize, offset];
                        if (valor === 'NULL') {
                            if (operador === '=') {
                                query += ` WHERE ${campo} IS NULL`
                            } else if (operador === '!=') {
                                query += ` WHERE ${campo} IS NOT NULL`
                            } else {
                                throw new Error(
                                    'Operador no válido para valores NULL',
                                )
                            }
                            params = [pageSize, offset] // No pasamos ? para NULL
                        } else {
                            query += ` WHERE ${campo} ${operador} ?`
                            params = [valor, pageSize, offset]
                        }
                    } catch (error) {
                        console.error('Error en el formato de búsqueda:', error)
                        reject('Formato de búsqueda inválido')
                        return
                    }
                }

                query += ` ORDER BY ROWID ASC LIMIT ? OFFSET ?;`

                console.log('query:', query, params)
                try {
                    const realDb = await getRealDatabase()
                    const result = await realDb.getAllAsync(query, params)
                    resolve(result)
                } catch (error) {
                    console.error('getTableData error:', error)
                    reject(error)
                }
            }
        })
    }

    // getCountTableData = (tableName) => {
    //     return new Promise((resolve, reject) => {
    //         if (isWeb()) {
    //             reject('Not implemented for web')
    //         } else {
    //             db.transaction(
    //                 (tx) => {
    //                     tx.executeSql(
    //                         `SELECT COUNT(*) as count FROM ${tableName};`,
    //                         [],
    //                         (_, result) => {
    //                             resolve(result.rows.item(0).count) // Devuelve el conteo
    //                         },
    //                         (_, error) => {
    //                             reject(error)
    //                         },
    //                     )
    //                 },
    //                 (error) => {
    //                     console.error('SQLite transaction error:', error)
    //                     reject(error)
    //                 },
    //                 null,
    //             )
    //         }
    //     })
    // }
    getCountTableData = (tableName, search = '') => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                reject('Not implemented for web')
            } else {
                let query = `SELECT COUNT(*) as count FROM ${tableName}`
                let params = []

                // Si hay búsqueda, construimos la condición WHERE
                if (search) {
                    try {
                        const [campo, operador, valor] = search
                            .split(',')
                            .map((s) => s.trim())

                        // Validamos que el operador sea permitido
                        const validOperators = ['=', '!=', '>', '<', '>=', '<=']
                        if (!validOperators.includes(operador) && valor !== 'NULL') {
                            throw new Error('Operador no válido')
                        }

                        if (valor === 'NULL') {
                            if (operador === '=') {
                                query += ` WHERE ${campo} IS NULL`
                            } else if (operador === '!=') {
                                query += ` WHERE ${campo} IS NOT NULL`
                            } else {
                                throw new Error(
                                    'Operador no válido para valores NULL',
                                )
                            }
                        } else {
                            query += ` WHERE ${campo} ${operador} ?`
                            params = [valor]
                        }
                    } catch (error) {
                        console.error('Error en el formato de búsqueda:', error)
                        reject('Formato de búsqueda inválido')
                        return
                    }
                }

                try {
                    const realDb = await getRealDatabase()
                    const result = await realDb.getFirstAsync(query, params)
                    resolve(result.count)
                } catch (error) {
                    console.error('getCountTableData error:', error)
                    reject(error)
                }
            }
        })
    }

    get_pendings_conections = async () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                resolve({ status: 1, results: {} })
                return
            }

            try {
                // ✅ Usar DatabaseSingleton en lugar de getWrappedDB
                const realDb = await getRealDatabase()
                const tables = [
                    {
                        name: SCHEDULES_STORE_NAMES.CHECKOUT,
                        statusField: 'status',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.CHECKIN,
                        statusField: 'status',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS,
                        statusField: 'status_send',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    {
                        name: LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS,
                        statusField: null,
                    },
                    { name: LEARNING_STORE_NAMES.ANSWERS_SURVEY, statusField: null },
                    {
                        name: SCHEDULES_STORE_NAMES.SCHEDULES_POS,
                        statusField: 'campaign_status',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.UPLOAD_IMAGES_PENDING,
                        statusField: null,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.STORES_PENDING_SEND,
                        statusField: null,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC,
                        statusField: 'status_send',
                        status_pending: STATUS_FORM_PENDING_SYNC.NO_SENDED,
                    },
                    {
                        name: SCHEDULES_STORE_NAMES.SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS,
                        statusField: null,
                    },
                ]

                const results = {}
                for (const table of tables) {
                    try {
                        // Verificar primero que la tabla existe
                        const tableCheck = await realDb.getFirstAsync(
                            `SELECT name FROM sqlite_master WHERE type='table' AND name=?;`,
                            [table.name],
                        )

                        if (!tableCheck) {
                            console.warn(
                                `⚠️ Tabla ${table.name} no existe, saltando...`,
                            )
                            results[table.name] = 0
                            continue
                        }

                        let result
                        if (table.statusField) {
                            result = await realDb.getFirstAsync(
                                `SELECT COUNT(*) as count FROM ${table.name} WHERE ${table.statusField} = ?`,
                                [table.status_pending],
                            )
                        } else {
                            result = await realDb.getFirstAsync(
                                `SELECT COUNT(*) as count FROM ${table.name}`,
                            )
                        }
                        results[table.name] = Number(result?.count) || 0
                    } catch (err) {
                        console.error(`❌ Error en la tabla ${table.name}:`, err)
                        results[table.name] = 0
                    }
                }

                const hasPending = Object.values(results).some(
                    (value) => typeof value === 'number' && value > 0,
                )
                const generalStatus = hasPending ? 0 : 1
                resolve({ status: generalStatus, results })
            } catch (error) {
                console.error('get_pendings_conections failed:', error)
                reject(error)
            }
        })
    }

    updateLoginStatus = async (isLoggedIn) => {
        try {
            if (isWeb()) {
                const { openDB } = await import('../src/db/indexDB')
                const db = await openDB()

                const tx = db.transaction([USER_PROFILE], 'readwrite')
                const store = tx.objectStore(USER_PROFILE)

                const users = await new Promise((resolve, reject) => {
                    const req = store.getAll()
                    req.onsuccess = () => resolve(req.result)
                    req.onerror = () => reject(req.error)
                })

                if (!users || users.length === 0) {
                    return { success: false, message: 'Usuario no encontrado' }
                }

                const user = users[0]
                user.login = !!isLoggedIn

                await new Promise((resolve, reject) => {
                    const req = store.put(user)
                    req.onsuccess = () => resolve()
                    req.onerror = () => reject(req.error)
                })

                return { success: true, user }
            }

            // 📱 Mobile / SQLite
            const realDb = await getRealDatabase()
            const user = await realDb.getFirstAsync(
                `SELECT * FROM ${USER_PROFILE} LIMIT 1;`,
            )

            if (!user) {
                return { success: false, message: 'Usuario no encontrado' }
            }

            await realDb.runAsync(`UPDATE ${USER_PROFILE} SET login = ?;`, [
                isLoggedIn ? 1 : 0,
            ])

            return {
                success: true,
                user: { ...user, login: !!isLoggedIn },
            }
        } catch (error) {
            console.error('updateLoginStatus error:', error)
            return { success: false, error }
        }
    }

    deleteAllTablesContents = async () => {
        console.log('🧹 Borrando tablas por login/logout')

        try {
            if (isWeb()) {
                await new Promise((resolve, reject) => {
                    const request = window.indexedDB.deleteDatabase(dbName)

                    request.onsuccess = () => {
                        console.log('Base de datos local eliminada exitosamente')
                        resolve()
                    }

                    request.onerror = (event) => {
                        console.error(
                            'Error al eliminar la base de datos local:',
                            event.target.error,
                        )
                        reject(event.target.error)
                    }
                })

                return
            }

            // 📱 SQLite
            const realDb = await getRealDatabase()

            const tables = [
                postsStoreName,
                versionsStoreName,
                LEARNING_STORE_NAMES.CATEGORIES,
                LEARNING_STORE_NAMES.COURSES,
                LEARNING_STORE_NAMES.CONTENTS,
                LEARNING_STORE_NAMES.EVALUATIONS,
                LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS,
                LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING,
                PORTFOLIO_STORE_NAMES.CATEGORIES,
                PORTFOLIO_STORE_NAMES.PRODUCTS,
                REACTIONS,
                BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS,
                BENEFITS_STORE_NAMES.BENEFIT_HISTORY,
                BENEFITS_STORE_NAMES.REDEEMS,
                BENEFITS_STORE_NAMES.POINTS_AWARDED,
                SCHEDULES_STORE_NAMES.STORES,
                POST_TABLE_NAMES.VIEWED_POSTS,
                SCHEDULES_STORE_NAMES.FORMS,
                SCHEDULES_STORE_NAMES.CAMPAINGS,
                SCHEDULES_STORE_NAMES.SCHEDULES,
                TRACKINGS.TRACKINGS,
                SCHEDULES_STORE_NAMES.SCHEDULES_POS,
                SCHEDULES_STORE_NAMES.CHECKIN_STEPS,
                SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES,
                SCHEDULES_STORE_NAMES.FORMS_ADDITIONALS,
                SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE,
                SCHEDULES_STORE_NAMES.PERFECT_STORE_VERSION,
            ]

            for (const table of tables) {
                await realDb.runAsync(`DROP TABLE IF EXISTS ${table};`)
            }

            console.log('✅ Todas las tablas eliminadas exitosamente')
        } catch (error) {
            console.error('❌ Error al eliminar las tablas:', error)
            throw error
        }
    }

    getTableRecordCount = async (tableName) => {
        try {
            const realDb = await getRealDatabase()
            const query = `SELECT COUNT(*) as count FROM ${tableName};`
            const result = await realDb.getFirstAsync(query, [])
            const count = result.count || 0
            return count
        } catch (error) {
            console.error(
                `Error al contar registros en la tabla ${tableName}:`,
                error,
            )
            throw error
        }
    }

    /**
     * 🆕 Obtiene el módulo del repositorio de usuario (con cache)
     * @returns {Promise<Object>}
     */
    getUserRepository = async () => {
        if (!__userRepositoryModule) {
            __userRepositoryModule =
                await import('../db-sqlite/repositories/user.repository')
        }
        return __userRepositoryModule
    }

    /**
     * 🆕 Guarda o actualiza un usuario usando el repositorio TypeScript
     * @param {Object} userData - Datos del usuario a guardar
     * @returns {Promise<void>}
     */
    upsertUser = async (userData) => {
        console.log('🔄 upsertUser (wrapper) =>', userData?.name)

        try {
            // ✅ Usar el módulo cacheado del repositorio
            const userRepository = await this.getUserRepository()
            await userRepository.upsertUser(userData)
            console.log('✅ Usuario guardado/actualizado correctamente')
        } catch (error) {
            console.error('❌ Error en upsertUser:', error)
            throw error
        }
    }

    /**
     * 🆕 Obtiene el usuario actual (primer usuario en la BD)
     * @returns {Promise<Object|null>}
     */
    getUserFromRepo = async () => {
        console.log('🔍 getUserFromRepo (wrapper)')

        try {
            const userRepository = await this.getUserRepository()
            const user = await userRepository.getUser()
            console.log('✅ Usuario obtenido:', user?.name)
            return user
        } catch (error) {
            console.error('❌ Error en getUserFromRepo:', error)
            throw error
        }
    }

    /**
     * 🆕 Actualiza campos específicos del usuario
     * @param {string} userId - ID del usuario
     * @param {Object} fields - Campos a actualizar
     * @returns {Promise<void>}
     */
    updateUserFields = async (userId, fields) => {
        console.log('🔄 updateUserFields (wrapper) =>', userId, fields)

        try {
            const userRepository = await this.getUserRepository()
            await userRepository.updateUserFields(userId, fields)
            console.log('✅ Campos de usuario actualizados')
        } catch (error) {
            console.error('❌ Error en updateUserFields:', error)
            throw error
        }
    }

    /**
     * 🆕 Ejecuta una query SQL pura contra la base de datos
     * @param {string} sqlQuery - Query SQL SELECT a ejecutar
     * @returns {Promise<Array>} Resultado de la query
     */
    executeRawQuery = async (sqlQuery) => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                reject('executeRawQuery not implemented for web')
                return
            }

            try {
                // Validar que sea una query SELECT por seguridad
                // const trimmedQuery = sqlQuery.trim().toLowerCase()
                // if (!trimmedQuery.startsWith('select')) {
                //     reject('Solo se permiten queries SELECT por seguridad')
                //     return
                // }
                const db = await getDb()
                const result = await db.getAll({ sql: sqlQuery })
                resolve(result)
            } catch (error) {
                console.error('❌ [executeRawQuery] Error:', error)
                reject(error)
            }
        })
    }
}

export const UserServices = new userServices()
